

import React, { useEffect, useState } from 'react';
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Badge,
  Card
} from 'react-bootstrap';
import Select from 'react-select';
import RangeSlider from 'react-bootstrap-range-slider';

export default function MyBids() {
  const [products, setProducts] = useState([]);
  const [uniqueCategories, setUniqueCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [uniqueSpecs, setUniqueSpecs] = useState([]);
  const [userBids, setUserBids] = useState([]);


  const fetchUserBids = (userId) => {
  fetch(`https://vyaparapi.emedha.in/api/buyer/bids/by-user/${userId}`)
    .then(res => res.json())
    .then(data => {
      setUserBids(data);
    })
    .catch(err => {
      console.error('Error fetching user bids:', err);
    });
};



const [filters, setFilters] = useState({
  category: '',
  subCategory: '',
  priceRange: [0, 100000],
  warranty: '',
  specsText: '' // Initialize as an empty object
});


  // Fetch products on mount
  useEffect(() => {
    fetch('https://vyaparapi.emedha.in/api/buyer/products/approved')
      .then(res => res.json())
      .then(data => {
        setProducts(data);

        const categories = [...new Set(data.map(p => p.category))];
        setUniqueCategories(categories.map(cat => ({ value: cat, label: cat })));
      });
  }, []);


const handleCategoryChange = (selected) => {
  setFilters({
    ...filters,
    category: selected?.value || '',
    subCategory: '',
    specs: {}
  });
};

const handleSubCategoryChange = (selected) => {
  setFilters({
    ...filters,
    subCategory: selected?.value || '',
    specs: {}
  });
};




useEffect(() => {
  const filteredProducts = products.filter(p =>
    p.category === filters.category &&
    (!filters.subCategory || p.subcategory === filters.subCategory)
  );

  console.log('✅ Filtered Products:', filteredProducts);

  const subCats = [
    ...new Set(
      products
        .filter(p => p.category === filters.category)
        .map(p => p.name?.trim())
        .filter(name => typeof name === 'string' && name)
    )
  ];

  const sortedSubCats = subCats.sort((a, b) => a.localeCompare(b));
  setSubCategories(sortedSubCats.map(sc => ({ value: sc, label: sc })));

  const specMap = {};
  filteredProducts.forEach(p => {
    if (p.specs) {
      console.log('🔍 Parsing specs string:', p.specs);
      const pairs = p.specs.split(',').map(s => s.trim());
      pairs.forEach(pair => {
        const [key, value] = pair.split(':').map(s => s.trim());
        if (key && value) {
          if (!specMap[key]) {
            specMap[key] = new Set();
          }
          specMap[key].add(value);
        }
      });
    }
  });

  console.log('🛠️ Spec Map before converting to object:', specMap);

  const finalSpecMap = {};
  for (const key in specMap) {
    finalSpecMap[key] = Array.from(specMap[key]);
  }

  console.log('✅ Final Spec Map (used in UI):', finalSpecMap);
  setUniqueSpecs(finalSpecMap);
}, [filters.category, filters.subCategory, products]);


const handleSpecChange = (specKey, value) => {
  setFilters(prev => ({
    ...prev,
    specs: {
      ...prev.specs,
      [specKey]: value
    }
  }));
};


const handleSubmitBid = () => {
   const user = JSON.parse(sessionStorage.getItem('user'));
  const userId = user?.id;

  const body = {
    user_id: userId,
    selected_specs: filters.specsText, // ✅ updated
    category: filters.category,
    sub_category: filters.subCategory,
    price_from: filters.priceRange[0],
    price_to: filters.priceRange[1],
    warranty: filters.warranty
  };

  fetch('https://vyaparapi.emedha.in/api/buyer/bids/create', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
    .then(res => res.json())
    .then(() => alert('🎯 Bid created successfully!'));
     fetchUserBids(userId); // 🔁 fetch updated list
};

useEffect(() => {
  const user = JSON.parse(sessionStorage.getItem('user'));
  if (user?.id) {
    fetchUserBids(user.id);
  }
}, []);

  return (
    <Container className="my-5">
      <Card className="shadow-lg p-4" style={{ border: 'none' }}>
        <h3 style={{ color: '#062d59', marginBottom: '1.5rem' }}>
          🎯 Create  Bid
        </h3>

        <Form>
          {/* Category Dropdown */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={2}><strong>Category</strong></Form.Label>
            <Col sm={10}>
              <Select
                options={uniqueCategories}
                value={uniqueCategories.find(opt => opt.value === filters.category)}
                onChange={(selected) =>
                  setFilters({
                    ...filters,
                    category: selected?.value || '',
                    subCategory: '',
                    specs: []
                  })
                }
                placeholder="Select Category..."
                isClearable
              />
            </Col>
          </Form.Group>

          {/* Subcategory Dropdown */}
          {filters.category && (
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm={2}><strong>Product Type</strong></Form.Label>
              <Col sm={10}>
                <Select
                  options={subCategories}
                  value={subCategories.find(opt => opt.value === filters.subCategory)}
                  onChange={(selected) =>
                    setFilters({
                      ...filters,
                      subCategory: selected?.value || '',
                      specs: []
                    })
                  }
                  placeholder="Select Product Type..."
                  isClearable
                />
              </Col>
            </Form.Group>
          )}

          {/* Price Range */}
          <Form.Group as={Row} className="mb-3 align-items-center">
            <Form.Label column sm={2}><strong>Price Range</strong></Form.Label>
            <Col sm={4}>
              <Form.Control
                type="number"
                value={filters.priceRange[0]}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    priceRange: [+e.target.value, filters.priceRange[1]]
                  })
                }
              />
            </Col>
            <Col sm={4}>
              <Form.Control
                type="number"
                value={filters.priceRange[1]}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    priceRange: [filters.priceRange[0], +e.target.value]
                  })
                }
              />
            </Col>
            <Col sm={2}>
              <RangeSlider
                min={0}
                max={100000}
                value={filters.priceRange[1]}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    priceRange: [filters.priceRange[0], +e.target.value]
                  })
                }
              />
            </Col>
          </Form.Group>

          {/* Warranty */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={2}><strong>Warranty</strong></Form.Label>
            <Col sm={10}>
              <Form.Select
                value={filters.warranty}
                onChange={(e) =>
                  setFilters({ ...filters, warranty: e.target.value })
                }
              >
                <option value="">-- Select Warranty --</option>
                <option value="1Years">1 Year</option>
                <option value="2Years">2 Years</option>
                  <option value="3Years">3 Years</option>
                <option value="3Years+">3 Years+</option>
              </Form.Select>
            </Col>
          </Form.Group>

<Form.Group as={Row} className="mb-4">
  <Form.Label column sm={2}><strong>Specifications</strong></Form.Label>
  <Col sm={10}>
    <Form.Control
      as="textarea"
      rows={5}
      placeholder="e.g. 8GB RAM, 6.7 inch Display, 5000mAh battery"
      value={filters.specsText || ''}
      onChange={(e) =>
        setFilters({ ...filters, specsText: e.target.value })
      }
    />
  </Col>
</Form.Group>



          {/* Submit */}
          <div className="text-end">
            <Button
              variant="danger"
              size="lg"
              onClick={handleSubmitBid}
              style={{
                backgroundColor: '#e3080c',
                borderColor: '#e3080c',
                padding: '0.75rem 2rem',
                fontWeight: 'bold',
              }}
            >
              Create Bid
            </Button>
          </div>
        </Form>
      </Card>
      {userBids.length > 0 && (
<Card className="mt-5 p-4 shadow" style={{ border: '1px solid #ccc', backgroundColor: '#fff' }}>
  <h4
    style={{
      color: '#062d59',
      borderBottom: '2px solid #e3080c',
      paddingBottom: '0.5rem',
      marginBottom: '1.5rem',
    }}
  >
    🎯 Your Submitted Bids
  </h4>

  {userBids.length === 0 && (
    <p style={{ color: '#777' }}>You haven't submitted any bids yet.</p>
  )}

  <Row>
    {userBids.map((bid, index) => (
      <Col md={4} key={bid.bid_id} className="mb-4">
        <Card
          className="h-100 shadow-sm"
          style={{
            backgroundColor: '#f9f9f9',
            borderLeft: '5px solid #e3080c',
            borderRadius: '8px',
          }}
        >
          <Card.Body>
          <p>
  <strong style={{ color: '#062d59' }}>📄 Bid ID:</strong> {bid.bid_id}
</p>
<p>
  <strong style={{ color: '#062d59' }}>📦 Category:</strong>{' '}
  {bid.category} / {bid.sub_category}
</p>
<p>
  <strong style={{ color: '#062d59' }}>💰 Price Range:</strong> ₹
  {bid.price_from} - ₹{bid.price_to}
</p>
<p>
  <strong style={{ color: '#062d59' }}>🔧 Warranty:</strong> {bid.warranty}
</p>
<p>
  <strong style={{ color: '#062d59' }}>🧩 Specs:</strong>{' '}
  <span style={{ color: '#e3080c' }}>{bid.selected_specs}</span>
</p>
<p>
  <strong style={{ color: '#062d59' }}>🕒 Created:</strong>{' '}
  {new Date(bid.created_at).toLocaleString()}
</p>
<p>
  <strong style={{ color: '#062d59' }}>📌 Status:</strong>{' '}
  <span style={{ color: bid.status.includes('Expired') ? 'red' : '#28a745' }}>
    {bid.status}
  </span>
</p>

          </Card.Body>
        </Card>
      </Col>
    ))}
  </Row>
</Card>


)}

    </Container>
  );
}
